package dev.lingvo.site.components.studio.editor

import dev.lingvo.shared.screenshots.doc.Point
import dev.lingvo.shared.screenshots.geom.Handle
import dev.lingvo.shared.screenshots.geom.Rect
import kotlin.math.hypot

/** Overlay handles use CSS pixels so zoom does not change their hit targets. */
internal data class StageHandle(val handle: Handle?, val point: Point)

/** Handles, guides and live numbers are drawn without updating panel state. */
internal class StageOverlay {
    var accent: String = ""
    var border: String = ""
    fun handles(bounds: Rect, viewport: StageViewport): List<StageHandle> {
        val x = bounds.x; val y = bounds.y; val w = bounds.w; val h = bounds.h
        return listOf(Handle.NW to Point(x,y), Handle.N to Point(x+w/2,y), Handle.NE to Point(x+w,y),
            Handle.E to Point(x+w,y+h/2), Handle.SE to Point(x+w,y+h), Handle.S to Point(x+w/2,y+h),
            Handle.SW to Point(x,y+h), Handle.W to Point(x,y+h/2)).map { StageHandle(it.first, viewport.toScreen(it.second)) } +
            StageHandle(null, viewport.toScreen(Point(x+w/2,y)).let { Point(it.x,it.y-24) })
    }
    fun hit(bounds: Rect, viewport: StageViewport, point: Point, touch: Boolean): StageHandle? =
        handles(bounds, viewport).firstOrNull { hypot(point.x-it.point.x, point.y-it.point.y) <= if(touch) 14 else 8 }
    fun draw(ctx: dynamic, viewport: StageViewport, bounds: Rect?, editable: Boolean, marquee: Rect?,
        guides: List<dev.lingvo.shared.screenshots.geom.Guide>, debug: String?) {
        val dpr = viewport.pixelRatio
        ctx.setTransform(dpr,0,0,dpr,0,0); ctx.clearRect(0,0,viewport.width,viewport.height)
        ctx.strokeStyle = accent; ctx.fillStyle = accent; ctx.lineWidth = 1
        fun rect(r: Rect) { val p=viewport.toScreen(Point(r.x,r.y)); ctx.strokeRect(p.x,p.y,r.w*viewport.zoom,r.h*viewport.zoom) }
        if (bounds != null) {
            rect(bounds)
            if (editable) handles(bounds,viewport).forEach { ctx.beginPath(); ctx.arc(it.point.x,it.point.y,4,0,6.283185307179586); ctx.fill() }
        }
        marquee?.let(::rect)
        guides.filterIsInstance<dev.lingvo.shared.screenshots.geom.Guide.Line>().forEach { guide ->
            ctx.beginPath()
            if (guide.axis == dev.lingvo.shared.screenshots.geom.Axis.X) {
                val x=viewport.toScreen(Point(guide.pos,0.0)).x; ctx.moveTo(x,0);ctx.lineTo(x,viewport.height)
            } else { val y=viewport.toScreen(Point(0.0,guide.pos)).y;ctx.moveTo(0,y);ctx.lineTo(viewport.width,y) }
            ctx.stroke()
        }
        if (debug != null) { ctx.fillStyle=accent;ctx.font="12px monospace";ctx.fillText(debug,8,20) }
    }
}
